import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import React, {useState} from "react";
import NewStepCombinationModal from "../NewStepCombinationModal";
import * as UserService from "../../api/UserService";
import DialogComponent from "../DialogComponent";
import EditComponent from "./EditComponent";
import DeleteComponent from "./DeleteComponent";
import {useTranslation} from "react-i18next";

function StepCombinationRow(props) {
    const [editModalOpen, setEditModalOpen] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [descriptionOpened, setDescriptionOpened] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'stepCombinationRow' });

    function openModal() {
        setEditModalOpen(true)
    }

    function closeModal() {
        setEditModalOpen(false)
    }

    function openDeleteModal() {
        setDeleteModalOpen(true)
    }

    function closeDeleteModal() {
        setDeleteModalOpen(false)
    }

    function openDescription() {
        if (descriptionOpened === true) {
            setDescriptionOpened(false)
        } else {
            setDescriptionOpened(true)
        }
    }

    function formatText() {
        let titel = ""
        let suffics = " → "
        let sequence = props.combination.sequence
        for (let i = 0; i < sequence.length - 1; i++) {
            titel = titel + sequence[i] + suffics
        }
        return titel + sequence[sequence.length - 1]
    }

    function deleteCombination() {
        UserService.deleteCombination(props.combination.id, () => {
            props.pullAllCombinations()
            closeDeleteModal()
        }, () => {
            window.alert(t('error'))
        })
    }

    return (
        <>
            <div className={descriptionOpened ?`${cabinetStyle.commonTileExtended} ${cabinetStyle.stepCombinationRow}` : `${cabinetStyle.commonTile} ${cabinetStyle.stepCombinationRow}`}

                 onClick={openDescription}>
                <div>
                    <header className={Style.h5Heading}>{formatText()}</header>
                </div>
                <div className={cabinetStyle.combinationsDescriptionRow} onClick={openDescription}>
                    {descriptionOpened && <div className={`${cabinetStyle.combinationDetails} ${Style.bodyBaseText}`}>{props.combination.text}</div>}
                    {!descriptionOpened && <div className={`${cabinetStyle.combinationDetails} ${Style.bodyBaseText}`}>{props.combination.text.substring(0, 60) + "..."}</div>}
                    <EditComponent toolTipText={t('editCombination')} openOnClick={openModal}/>
                    <DeleteComponent toolTipText={t('deleteCombination')} openOnClick={openDeleteModal}/>
                </div>
            </div>
            {editModalOpen &&
                <NewStepCombinationModal onClose={closeModal}
                                         combination={props.combination}
                                         sequenceText={formatText()}
                                         pullAllCombinations={props.pullAllCombinations}
                ></NewStepCombinationModal>}
            {
                deleteModalOpen &&
                <DialogComponent
                    onClose={closeDeleteModal}
                    title={t('deleteCombination')+"?"}
                    onConfirm={deleteCombination}
                >
                </DialogComponent>
            }
        </>

    )
}

export default StepCombinationRow